import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ROLE_FAIL = "ADMIN-USER:MODIFY_ROLE_FAIL";

export interface ModifyRoleFailAction extends Action {
  type: typeof MODIFY_ROLE_FAIL;
  organization: OrganizationKeyName;
}

export const modifyRoleFailAction = (
  organization: OrganizationKeyName
): ModifyRoleFailAction => ({
  type: MODIFY_ROLE_FAIL,
  organization,
});
